import React from 'react';
import { baseImage } from '../constants/categoryconstants';

const ImageItem = (props) => {
    return (
        <li key={props.i} className="lurebuilder-image-item">
            <img 
                src={props.img.imageUrl}
                className={props.isSelected !== props.i ? props.isActive ? "lurebuilder-main-image" : "lurebuilder-main-image-nostock" : props.isActive ? "lurebuilder-main-image-selected" : "lurebuilder-main-image-selected-nostock"}
                alt="img thumbnail"
                index={props.i}
                alt={props.img.title}
                onClick={props.isActive ? event => props.handleImageClick(event) : null}
                category={props.img.category}
                imageid={props.img.ImageId}
                active={`${props.img.Active}`}
            />
            <img src={baseImage} className="lurebuilder-base-image" />
            <span className={props.isActive ? "lurebuilder-main-image-nostock-text-hidden" : "lurebuilder-main-image-nostock-text"}><i className="fa fa-exclamation-circle"></i> Not available</span>
            <p>{props.img.title}</p>
        </li>
    );
}

export default ImageItem;